(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-collection-fit-finder"] && !Shopify.designMode) return;
  try {
    (function () {
    var finders = document.querySelectorAll('[data-sr-collection-fit-finder]');

    if (!finders.length) {
      return;
    }

    finders.forEach(function (finder) {
      var resultScript = finder.querySelector('[data-sr-fit-results]');
      var resultTitle = finder.querySelector('[data-sr-fit-result-title]');
      var resultBody = finder.querySelector('[data-sr-fit-result-body]');
      var productsTitle = finder.querySelector('[data-sr-fit-products-title]');
      var productsNote = finder.querySelector('[data-sr-fit-products-note]');
      var products = finder.querySelectorAll('[data-sr-fit-product]');
      var answers = finder.querySelectorAll('[data-sr-fit-answer]');
      var results = {};
      var selected = {};

      if (!resultScript || !resultTitle || !resultBody) {
        return;
      }

      try {
        results = JSON.parse(resultScript.textContent);
      } catch (error) {
        return;
      }

      function updateResult() {
        var scores = { a: 0, b: 0, c: 0 };
        var topKey = 'a';

        Object.keys(selected).forEach(function (question) {
          var key = selected[question];

          if (scores[key] !== undefined) {
            scores[key] += 1;
          }
        });

        Object.keys(scores).forEach(function (key) {
          if (scores[key] > scores[topKey]) {
            topKey = key;
          }
        });

        if (!results[topKey]) {
          return;
        }

        resultTitle.textContent = results[topKey].title;
        resultBody.textContent = results[topKey].body;

        updateProducts(topKey);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'sr_collection_fit_finder_result',
          collection_handle: finder.getAttribute('data-collection-handle'),
          result_key: topKey,
          answered_questions: Object.keys(selected).length,
          visible_products: finder.querySelectorAll('[data-sr-fit-product].is-visible').length
        });
      }

      function showProduct(product) {
        product.classList.add('is-visible');
        product.hidden = false;
        product.removeAttribute('aria-hidden');
      }

      function updateProducts(resultKey) {
        var shown = 0;
        var maxProducts = 7;

        if (!products.length) {
          return;
        }

        products.forEach(function (product) {
          product.classList.remove('is-visible');
          product.hidden = true;
          product.setAttribute('aria-hidden', 'true');
        });

        products.forEach(function (product) {
          if (shown < maxProducts && product.getAttribute('data-result') === resultKey) {
            showProduct(product);
            shown += 1;
          }
        });

        if (productsTitle && results[resultKey].productsTitle) {
          productsTitle.textContent = results[resultKey].productsTitle;
        }

        if (productsNote) {
          productsNote.textContent = productsNote.getAttribute('data-selected-note');
        }
      }

      answers.forEach(function (answer) {
        answer.setAttribute('aria-pressed', 'false');

        answer.addEventListener('click', function () {
          var question = answer.getAttribute('data-question');
          var result = answer.getAttribute('data-result');
          var groupAnswers = finder.querySelectorAll('[data-sr-fit-answer][data-question="' + question + '"]');

          groupAnswers.forEach(function (groupAnswer) {
            groupAnswer.classList.remove('is-selected');
            groupAnswer.setAttribute('aria-pressed', 'false');
          });

          answer.classList.add('is-selected');
          answer.setAttribute('aria-pressed', 'true');
          selected[question] = result;
          updateResult();
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
